import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
export function RuiIconCalendar({
  class: className,
  size = "sm",
  ...props
}) {
  return /* @__PURE__ */jsxs("svg", {
    ...props,
    class: cx("rui-icon", size === "md" && "rui-icon--md", className),
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true",
    children: [/* @__PURE__ */jsx("path", {
      d: "M8 2v4"
    }), /* @__PURE__ */jsx("path", {
      d: "M16 2v4"
    }), /* @__PURE__ */jsx("rect", {
      width: "18",
      height: "18",
      x: "3",
      y: "4",
      rx: "2"
    }), /* @__PURE__ */jsx("path", {
      d: "M3 10h18"
    })]
  });
}